<div class="position-fixed z-9 w-100">
  <div #navTopStrip class="top-strip">
    <div
      class="top-strip__container container d-flex align-items-center justify-content-between"
    >
      <div class="top-strip__left top-strip__left--web">
        <a
          target="_blank"
          title="Meity"
          role="button"
          class="d-flex align-items-center meity-logo"
          (click)="
            openLink({
              url: 'https://www.meity.gov.in/',
              img: 'https://media.umangapp.in/cdn/landing/theme/icons/meit-dark.svg',
              width: '190px'
            })
          "
        >
          <!-- <img
            src="https://media.umangapp.in/cdn/landing/theme/icons/meit-header.svg"
            alt="meity"
            width="179"
            height="40"
            class="header-logo-web"
            loading="lazy"
            fetchpriority="high"
          /> -->
          <img
            class="resp-image"
            src="https://media.umangapp.in/cdn/landing/theme/icons/emblem-mobile.svg"
            alt="meity"
            width="20"
            height="31"
            loading="lazy"
            fetchpriority="high"
          />
          <p class="mb-0">{{ "meity.title" | translate }}</p>
        </a>
        <a
          *ngIf="false"
          role="button"
          target="_blank"
          title="Azadi Ka Amrit Mahotsav"
          (click)="
            openLink({
              url: 'https://amritmahotsav.nic.in/',
              img: 'https://media.umangapp.in/cdn/landing/theme/icons/akam-dark.svg'
            })
          "
        >
          <img
            src="https://media.umangapp.in/cdn/landing/theme/icons/akam-logo.svg"
            alt="akam"
            width="70"
            height="38"
            loading="lazy"
            fetchpriority="high"
        /></a>
        <a
          role="button"
          target="_blank"
          class="di-logo"
          title="Digital India"
          (click)="
            openLink({
              url: 'https://www.digitalindia.gov.in/',
              img: 'https://media.umangapp.in/cdn/landing/theme/icons/di.svg'
            })
          "
        >
          <img
            src="https://media.umangapp.in/cdn/landing/theme/icons/di.svg"
            alt="digital india"
            width="61"
            height="32"
            loading="lazy"
            fetchpriority="high"
          />
        </a>
      </div>
      <div class="top-strip__right d-flex align-items-center">
        <div>
          <span class="theme-switch-icons" [innerHTML]="darkModeIconSVG | safeHTML"  *ngIf="!darkMode" (click)="setTheme()"></span>
          <span class="theme-switch-icons" [innerHTML]="lightModeIconSVG | safeHTML"  *ngIf="darkMode" (click)="setTheme()"></span>
        </div>
        <div *ngIf="importantUpdates?.length" class="important-updates d-flex align-items-center justify-content-center">
          <button class="d-flex align-items-center" (click)="toggleDrawer()"><span [innerHTML]="importantUpdatesSVG | safeHTML"></span> {{'extraTrans.important' | translate}}</button>
        </div>        
        <div
          class="isl-bot-icon align-items-center d-sm-flex"
          matTooltip="Indian Sign Language"
          matTooltipClass="my-custom-tooltip-class"
          (click)="navigateToChatbot()"
        >
          <span class="isl-bot-icon__text d-none d-sm-inline-block">{{
            "isl-chatbot.isl-chat" | translate
          }}</span>
          <span
            class="isl-bot-icon__icon d-flex align-items-center justify-content-center"
            [innerHTML]="islChatbotFlatSVG | safeHTML"
          ></span>
        </div>
        <app-language-selection></app-language-selection>
      </div>
    </div>
  </div>

  <div class="main-navigation d-flex align-items-center position-relative">
    <div class="container d-flex align-items-center justify-content-between">
      <div class="main-navigation__left d-flex align-items-center">
        <app-brand-logo></app-brand-logo>
        <a
          *ngIf="false"
          role="button"
          target="_blank"
          class="nav-brand-logo brand-logo--g20"
          title="g20"
          (click)="
            openLink({
              url: 'https://www.g20.org/en/',
              img: 'https://media.umangapp.in/cdn/landing/theme/icons/g20.png'
            })
          "
        >
          <img
            src="https://media.umangapp.in/cdn/landing/theme/icons/g20.png"
            alt="g20"
            width="60"
            height="55"
            class="resp-image1"
            loading="lazy"
            fetchpriority="high"
          />
        </a>
      </div>
      <div class="main-navigation__right">
        <div class="d-flex">
          <div
            routerLink="/search"
            role="button"
            [routerLinkActive]="'icon-search--active'"
            class="icon-search global-search-icon"
          >
            <span
              [innerHTML]="searchIconSVG | safeHTML"
              class="grayed-search-icon bright"
            ></span>
            <span
              [innerHTML]="searchIconActiveSVG | safeHTML"
              class="active-search-icon"
            ></span>
          </div>
          <!-- <span class="global-search-icon me-3" routerLink="/search" [innerHTML]="searchIconSVG | safeHTML"></span> -->
          <div class="hamburger-menu" (click)="openSideDrawer()">
            <img
              src="assets/images/hamburger-light.png"
              alt="hamburger"
              width="32"
              height="32"
              loading="lazy"
              fetchpriority="high"
              class="dark-mode-umg"
            />
            <img
              src="https://media.umangapp.in/cdn/landing/theme/icons/hamburger.png"
              alt="hamburger"
              width="32"
              height="32"
              loading="lazy"
              fetchpriority="high"
              class="light-mode-umg"
            />
          </div>
        </div>
        <ul class="gap-40 p-0 mb-0 list-unstyled">
          <li>
            <app-navbar-link title="pages.home" link="/"></app-navbar-link>
          </li>
          <li>
            <app-navbar-link
              title="pages.about-us"
              link="/aboutus"
            ></app-navbar-link>
          </li>
          <li>
            <app-navbar-link
              title="pages.services"
              link="/services"
            ></app-navbar-link>
          </li>
          <li>
            <app-navbar-link
              title="pages.dashboard"
              link="/dashboard"
            ></app-navbar-link>
          </li>
          <!-- <li>
            <app-navbar-link
              title="pages.our-partners"
              link="/partners"
            ></app-navbar-link>
          </li> -->
          <li>
            <app-navbar-link
              title="pages.schemes"
              link="/scheme/dashboard"
            ></app-navbar-link>
          </li>
          <li
            routerLink="/search"
            role="button"
            [routerLinkActive]="'icon-search--active'"
            class="icon-search"
            title="Search"
          >
            <span
              [innerHTML]="searchIconSVG | safeHTML"
              class="grayed-search-icon bright"
            ></span>
            <span
              [innerHTML]="searchIconActiveSVG | safeHTML"
              class="active-search-icon"
            ></span>
          </li>
          <li *ngIf="isLoginBtnVisible">
            <app-login-btn></app-login-btn>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Side drawer menu -->
<div #sideDrawer class="mobile-drawer-menu">
  <div
    class="mobile-drawer-header d-flex align-items-center justify-content-between"
  >
    <app-brand-logo></app-brand-logo>
    <span class="drawer-close dark-mode-umg" (click)="closeSideDrawer()">
      <app-close-light-svg></app-close-light-svg>
    </span>
    <img
      src="https://media.umangapp.in/cdn/landing/close.svg"
      alt=""
      class="drawer-close light-mode-umg"
      width="20"
      height="20"
      loading="lazy"
      fetchpriority="high"
      (click)="closeSideDrawer()"
    />
  </div>
  <ul class="list-unstyled">
    <li>
      <app-navbar-link
        title="pages.home"
        link="/"
        navLinkClass="drawer-nav-link"
        (onNavigate)="closeSideDrawer()"
      ></app-navbar-link>
    </li>
    <li>
      <app-navbar-link
        title="pages.about-us"
        link="/aboutus"
        navLinkClass="drawer-nav-link"
        (onNavigate)="closeSideDrawer()"
      ></app-navbar-link>
    </li>
    <li>
      <app-navbar-link
        title="pages.services"
        link="/services"
        navLinkClass="drawer-nav-link"
        (onNavigate)="closeSideDrawer()"
      ></app-navbar-link>
    </li>
    <li>
      <app-navbar-link
        title="pages.dashboard"
        link="/dashboard"
        navLinkClass="drawer-nav-link"
        (onNavigate)="closeSideDrawer()"
      ></app-navbar-link>
    </li>
    <!-- <li>
      <app-navbar-link
        title="pages.our-partners"
        link="/partners"
        navLinkClass="drawer-nav-link"
        (onNavigate)="closeSideDrawer()"
      ></app-navbar-link>
    </li> -->
    <li>
      <app-navbar-link
        title="pages.schemes"
        link="/scheme/dashboard"
        navLinkClass="drawer-nav-link"
        (onNavigate)="closeSideDrawer()"
      ></app-navbar-link>
    </li>
    <li>
      <app-login-btn></app-login-btn>
    </li>
  </ul>
</div>

<!-- Side drawer menu overlay -->
<div #overlay class="drawer-overlay" (click)="closeSideDrawer()"></div>
<div class="other-details" id="umang-islchatbot"></div>
